import { render, staticRenderFns } from "./busmaininfo.vue?vue&type=template&id=58d4dcd5&"
import script from "./busmaininfo.vue?vue&type=script&lang=js&"
export * from "./busmaininfo.vue?vue&type=script&lang=js&"
import style0 from "./busmaininfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports